import styled from "@emotion/styled"
import { theme } from "@/theme"

export const Main = styled.main`
    background-color: ${theme.palette.intentions.cleanerBackground.main};
`

export const PropertyBar = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 16px;
    background-color: ${theme.palette.intentions.primary.light};
    color: ${theme.palette.intentions.primary.dark};
    font-size: 15px;
    font-weight: bold;
`

// 画面幅いっぱいの品目リストと違い、余白を持たせたい要素に使う。
export const PaddedArea = styled.div`
    padding: 16px;
`

export const InstructionBanner = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 8px;
    padding: 12px 14px;
    border: 1px solid #ffe0a3;
    border-radius: 8px;
    background-color: #fff8e1;
    color: #8a6d3b;
    font-size: 14px;
    font-weight: bold;
    line-height: 1.5;
`

export const TitleAccent = styled.span`
    width: 4px;
    height: 16px;
    border-radius: 2px;
    background-color: ${theme.palette.intentions.primary.main};
`

// 品目リストは画面幅いっぱいの1枚もので、カテゴリ見出しと品目の間は空けない。
export const ItemList = styled.div`
    display: flex;
    flex-direction: column;
    background-color: #fff;
    border-top: 1px solid ${theme.palette.intentions.cleanerGray.light};
    border-bottom: 1px solid ${theme.palette.intentions.cleanerGray.light};
    /* 下は固定フッターのクリアランス */
    margin-bottom: 64px;
`

export const CategoryBar = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 16px;
    border-bottom: 1px solid ${theme.palette.intentions.cleanerGray.light};
    background-color: ${theme.palette.intentions.cleanerGray.light};
    font-size: 13px;
    font-weight: bold;
    color: ${theme.palette.intentions.text.primary};
`

// 報告内容の見出し。品目のカテゴリ見出しと違い、入力を促す帯ではないので灰色基調にする。
export const SummaryBar = styled(CategoryBar)`
    color: ${theme.palette.intentions.cleanerGray.dark};
`

export const ItemRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 12px 16px;
    border-bottom: 1px solid ${theme.palette.intentions.cleanerGray.light};

    &:last-of-type {
        border-bottom: none;
    }
`

export const ItemName = styled.div<{ selected: boolean }>`
    flex: 1;
    min-width: 0;
    font-size: 15px;
    font-weight: ${({ selected }) => (selected ? "bold" : "normal")};
    color: ${({ selected }) =>
        selected
            ? theme.palette.intentions.primary.dark
            : theme.palette.intentions.text.primary};
    overflow-wrap: anywhere;
`

export const Stepper = styled.div`
    display: flex;
    flex-shrink: 0;
    align-items: center;
    gap: 4px;
`

export const StepperButton = styled.button`
    width: 36px;
    height: 36px;
    display: grid;
    place-items: center;
    border: 1px solid ${theme.palette.intentions.cleanerGray.main};
    border-radius: 8px;
    background-color: #fff;
    color: ${theme.palette.intentions.primary.dark};
    cursor: pointer;

    &:disabled {
        color: ${theme.palette.intentions.cleanerGray.main};
        cursor: default;
    }
`

export const QuantityValue = styled.span<{ selected: boolean }>`
    width: 36px;
    text-align: center;
    font-size: 16px;
    font-weight: bold;
    color: ${({ selected }) =>
        selected
            ? theme.palette.intentions.primary.dark
            : theme.palette.intentions.cleanerGray.dark};
`

export const SummaryQuantity = styled.span`
    flex-shrink: 0;
    font-size: 16px;
    font-weight: bold;
    color: ${theme.palette.intentions.text.primary};
`

export const ReportedAt = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    color: ${theme.palette.intentions.cleanerGray.dark};
`

export const EmptyState = styled.div`
    display: grid;
    place-items: center;
    min-height: 96px;
    padding: 16px;
    border: 1px dashed ${theme.palette.intentions.cleanerGray.main};
    background-color: ${theme.palette.intentions.cleanerBackground.main};
    color: ${theme.palette.intentions.cleanerGray.dark};
    font-size: 13px;
    text-align: center;
`

export const CenteredBody = styled.div`
    display: grid;
    place-items: center;
    gap: 16px;
    min-height: 50vh;
    padding: 24px;
    text-align: center;
`

export const DoneIcon = styled.div`
    display: grid;
    place-items: center;
    width: 72px;
    height: 72px;
    border-radius: 50%;
    background-color: ${theme.palette.intentions.primary.light};
    color: ${theme.palette.intentions.primary.main};
`

export const DoneBody = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    padding: 32px 16px 16px;
    text-align: center;
`
